import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { VIEWPORT_TOOL_PRESSED_CLASSES } from "@/viewport-tools/core";
import { collectViewportToolsetRailRendererResults } from "@/viewport-tools/rail/renderers";
import type { ViewportToolsetsRailProps } from "@/viewport-tools/rail/types";

export function ViewportToolsetsHeader({
  enabledToolsets,
  controllers,
}: ViewportToolsetsRailProps) {
  const items = collectViewportToolsetRailRendererResults(
    enabledToolsets ?? [],
    controllers
  ).flatMap((result) => (result.item ? [result.item] : []));

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      {items.map((item) => (
        <Button
          key={item.id}
          type="button"
          variant="ghost"
          size="sm"
          disabled={item.disabled}
          aria-pressed={Boolean(item.active || item.selected)}
          onClick={item.onClick}
          className={cn(
            "gap-1.5 px-2.5 text-[11px] uppercase tracking-wider text-muted-foreground hover:text-foreground",
            VIEWPORT_TOOL_PRESSED_CLASSES
          )}
        >
          <span aria-hidden="true" className="flex items-center justify-center">{item.icon}</span>
          <span>{item.label}</span>
        </Button>
      ))}
    </div>
  );
}
